// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Z8Urqn8Q_hQCDw1h5hJx{background:var(--border-neutral-default);width:calc(100% - 40px);height:1px;margin:16px 20px;display:flex}.lJlSNtg1ykzB0PFH6MSw{align-items:center;gap:10px;padding-top:8px;padding-bottom:12px;padding-left:20px;display:flex}.IUporUwmqqQBQil2LsP5{height:24px;font-size:16px;line-height:24px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"separator": `Z8Urqn8Q_hQCDw1h5hJx`,
	"search": `lJlSNtg1ykzB0PFH6MSw`,
	"searchInput": `IUporUwmqqQBQil2LsP5`
};
export default ___CSS_LOADER_EXPORT___;
